import { toast } from "react-hot-toast"
import { setLoading, setToken } from "../../slice/authSlice"
import { resetCart } from "../../slice/cartSlice"
import { apiConnector } from "../apiconnector"
import { setUser } from "../../slice/profileSlice"
import { endpoints } from "../apis"

const {
    SENDOTP_API,
    SIGNUP_API,
    LOGIN_API,
    RESETPASSTOKEN_API,
    RESETPASSWORD_API,
} = endpoints;

export function sendOtp(email, navigate) {
    return async (dispatch) => {
        const toastId = toast.loading("Loading...");
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", SENDOTP_API, {
                email,
                checkUserPresent: true,
            });
            // console.log("SENDOTP API RESPONSE............", response);

            // console.log(response.data.success);

            if (!response.data.success) {
                throw new Error(response.data.message);
            }

            toast.success("OTP Sent Successfully");
            navigate("/verify-email");
        } catch (error) {
            console.log("SENDOTP API ERROR............", error);
            toast.error(error?.response?.data?.message || "Check Your mail");
        }
        dispatch(setLoading(false));
        toast.dismiss(toastId);
    };
}

//*verify Email
export function signUp(
    accountType,
    firstName,
    lastName,
    email,
    password,
    confirmPassword,
    otp,
    navigate
) {
    return async (dispatch) => {
        const toastId = toast.loading("Loading...");
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", SIGNUP_API, {
                accountType,
                firstName,
                lastName,
                email,
                password,
                confirmPassword,
                otp,
            });

            // console.log("SIGNUP API RESPONSE............", response);

            if (!response.data.success) {
                throw new Error(response.data.message);
            }
            toast.success("Signup Successful");
            navigate("/login");
        } catch (error) {
            console.log("SIGNUP API ERROR............", error);
            toast.error(error?.response?.data?.message || "Failed");
            navigate("/signup");
        }
        dispatch(setLoading(false));
        toast.dismiss(toastId);
    };
}

export function login(email, password, navigate) {
    return async (dispatch) => {
        const toastId = toast.loading("Loading...");
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", LOGIN_API, {
                email,
                password,
            });

            // console.log("LOGIN API RESPONSE............", response);

            if (!response.data.success) {
                throw new Error(response.data.message);
            }

            toast.success("Login Successful");
            dispatch(setToken(response.data.token));
            const userImage = response.data?.user?.image
                ? response.data.user.image
                : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.user.firstName} ${response.data.user.lastName}`;
            // setUser remove from despatch(setUser(105
            dispatch(setUser({ ...response.data.user, image: userImage }));
            localStorage.setItem("token", JSON.stringify(response.data.token));
            localStorage.setItem("user", JSON.stringify(response.data.user))
            navigate("/dashboard/my-profile");
        } catch (error) {
            console.log("LOGIN API ERROR............", error);
            toast.error(error?.response?.data?.message || "Failed");
        }
        dispatch(setLoading(false));
        toast.dismiss(toastId);
    };
}

export function logout(navigate) {
    return (dispatch) => {
        dispatch(setToken(null));
        // setUser remove from despatch(setUser( line 123
        dispatch(setUser(null));
        dispatch(resetCart());
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        toast.success("Logged Out");
        navigate("/");
    };
}

// yaha se code kara hai (video)
export function getPasswordResetToken(email, setEmailSend) {
    return async (dispatch) => {
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", RESETPASSTOKEN_API, { email })
            console.log("RESET PASSWORD TOKEN RESPONSE....", response);

            if (!response.data.success) {
                throw new Error(response.data.message)
            }

            toast.success("Reset Email sent");
            setEmailSend(true)

        } catch (error) {
            console.log("RESET PASSWORD TOKEN Error", error);
            toast.error("Faild to send email for resetting password");
        }
        dispatch(setLoading(false));
    }
}

// Reset Password
export function resetPassword(password, confirmPassword, token) {
    return async (dispatch) => {
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", RESETPASSWORD_API, {
                password, confirmPassword, token
            });
            console.log("RESET password RESPONSE...", response);

            if (!response.data.success) {
                throw new Error(response.data.message);
            }

            toast.success("Password has been reset successfully");
        } catch (error) {
            console.log("RESET PASSWORD TOKEN Error".error);
            toast.error("Unable to reset password");
        }
        dispatch(setLoading(false));
    }
}